
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Popup from "../components/PopUP";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import TableFooter from "../components/TableFooter";
import DeleteModal from "../components/DeleteModal";
import api from "../Api";
import { IMAGE_URL, API_BASE_URL } from "../utils/constants";
import axios from 'axios'

const AIRPORT_LIST_URL = `${API_BASE_URL}/airport/airport-details/`;
const AIRPORT_UPLOAD_URL = `${API_BASE_URL}/airport/upload-airport-json/`;
const AIRPORT_UPLOAD_STATUS_URL = `${API_BASE_URL}/airport/upload-airport-json-status/`;
const AIRPORT_DELETE_URL = `${API_BASE_URL}/airport/bulk-delete-airport/`;
const AIRPORT_APPROVE_URL = `${API_BASE_URL}/airport/bulk-approve-airport`;
const AIRPORT_DISAPPROVE_URL = `${API_BASE_URL}/airport/bulk-disapprove-airport/`;

export default function UploadAirPortsDetails() {
  const [glossaryDetails, setGlossaryDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [apiError, setApiError] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadTaskId, setUploadTaskId] = useState(null);
  

  const [hasUploaded, setHasUploaded] = useState(false);

  const [uploadMessage, setUploadMessage] = useState("");

  const [pagination, setPagination] = useState({
    count: 0,
    total_pages: 0,
    next: null,
    previous: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [selectedGlossaryIds, setSelectedGlossaryIds] = useState([]);
  const [bulkActionLoading, setBulkActionLoading] = useState(false);

const fetchGlossaryDetails = useCallback(async () => {
  try {
    const response = await api.get(
      `${AIRPORT_LIST_URL}?page=${currentPage}&q=${encodeURIComponent(query)}`,
      { withCredentials: true }
    );

    const data = response.data;
    const results = Array.isArray(data) ? data : data?.results;

    setGlossaryDetails(Array.isArray(results) ? results : []);

    setPagination({
      count: data?.count ?? (Array.isArray(results) ? results.length : 0),
      total_pages: data?.total_pages ?? 1,
      next: data?.next ?? null,
      previous: data?.previous ?? null,
    });

    setApiError("");
  } catch (error) {
    console.error("Airport API Error:", error);
    // setApiError(
    //   error.response?.data?.detail ||
    //     "Failed to fetch airport details."
    // );
  }
}, [currentPage, query]);

  useEffect(() => {
    let isMounted = true;

    const loadAirportDetails = async () => {
      setLoading(true);

      try {
        await fetchGlossaryDetails();
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadAirportDetails();

    return () => {
      isMounted = false;
    };
  }, [fetchGlossaryDetails]);

  const getAirportName = (item) =>
    item.name ??
    item.general_information?.name ??
    item.general_information?.airport_name ??
    "";

  const getAirportIata = (item) =>
    item.iata_code ?? item.codes?.iata_code ?? item.codes?.iata ?? "";

  const getAirportIcao = (item) =>
    item.icao ??
    item.icao_code ??
    item.codes?.icao ??
    item.codes?.icao_code ??
    "";

  const getAirportCountry = (item) =>
    item.country ??
    item.location?.country ??
    item.location?.country_name ??
    "";

  const getAirportLatitude = (item) =>
    item.latitude_deg ??
    item.latitude ??
    item.location?.latitude_deg ??
    item.location?.latitude ??
    "";

  const getAirportLongitude = (item) =>
    item.longitude_deg ??
    item.longitude ??
    item.location?.longitude_deg ??
    item.location?.longitude ??
    "";

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);

    setApiError("");
    setPopupMessage("");
    setUploadMessage("");

    const jsonFiles = files.filter(
      (file) =>
        file.type === "application/json" ||
        file.name.toLowerCase().endsWith(".json")
    );

    if (jsonFiles.length !== files.length) {
      setApiError("Only JSON files are allowed.");
    }

    setSelectedFiles(jsonFiles);
  };

  const handleSelectGlossary = (id) => {
    setSelectedGlossaryIds((previous) =>
      previous.includes(id)
        ? previous.filter((selectedId) => selectedId !== id)
        : [...previous, id]
    );
  };

  const handleSelectAllGlossary = (checked) => {
    const visibleIds = filteredGlossaryDetails.map((item) => item.id);

    setSelectedGlossaryIds((previous) =>
      checked
        ? [...new Set([...previous, ...visibleIds])]
        : previous.filter((id) => !visibleIds.includes(id))
    );
  };

  // Poll the backend until the background upload has finished.
  const checkAirportUploadStatus = async (taskId) => {
    try {
      const response = await api.get(
        `${AIRPORT_UPLOAD_STATUS_URL}${taskId}`,
        { withCredentials: true }
      );

      const data = response.data;

      if (data.status === "completed") {
        const inserted = data.inserted_count || 0;
        const updated = data.updated_count || 0;
        const invalid = data.invalid_files || 0;
        const failed = data.failed_count || 0;
        const alreadyExists = data.already_exists_files || [];

        const messages = [
          "Airport upload completed.",
          `Inserted: ${inserted}`,
          `Updated: ${updated}`,
        ];

        if (alreadyExists.length > 0) {
          messages.push(
            `ALREADY EXISTS: ${alreadyExists.join(", ")}`
          );
        }

        if (invalid > 0) {
          messages.push(`Invalid: ${invalid}`);

          const invalidDetails = (data.invalid_file_details || [])
            .map((item) => `${item.file_name}: ${item.error}`)
            .join(" | ");

          if (invalidDetails) {
            messages.push(invalidDetails);
          }
        }

        if (failed > 0) {
          messages.push(`Failed: ${failed}`);
        }

        const successMessage = [
          inserted > 0 ? `Inserted: ${inserted}` : "",
          updated > 0 ? `Updated: ${updated}` : "",
        ].filter(Boolean);

        if (successMessage.length > 0) {
          setPopupMessage(
            `Airport upload completed successfully.\n${successMessage.join("\n")}`
          );
        }
        setUploadTaskId(null);
        setSelectedFiles([]);
        setLoading(false);
        setCurrentPage(1);
        setHasUploaded(true);

        // Refresh the listing after processing has completed.
        await fetchGlossaryDetails();
        return;
      }

      if (data.status === "failed") {
        setPopupMessage(
          data.message || data.detail || "Airport upload failed."
        );
        setUploadTaskId(null);
        setLoading(false);
        return;
      }

      // Still processing: check the status again after one second.
      setTimeout(() => {
        checkAirportUploadStatus(taskId);
      }, 1000);
    } catch (error) {
      console.error(
        "Airport upload status error:",
        error.response?.data || error
      );

      const detail = error.response?.data?.detail;

      setPopupMessage(
        typeof detail === "string"
          ? detail
          : error.response?.data?.message ||
              "Failed to check airport upload status."
      );

      setUploadTaskId(null);
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setApiError("");
    setPopupMessage("");
console.log("API_BASE_URL:", API_BASE_URL);
console.log("AIRPORT_UPLOAD_URL:", AIRPORT_UPLOAD_URL);

    const form = event.currentTarget;
    const files = selectedFiles.length
      ? selectedFiles
      : Array.from(form.elements.upload_csv?.files || []);

    if (files.length === 0) {
      setApiError("Please select at least one JSON file.");
      return;
    }

    if (uploadTaskId) {
      setApiError("An airport upload is already processing.");
      return;
    }

    const invalidFiles = files.filter(
      (file) => !file.name.toLowerCase().endsWith(".json")
    );

    if (invalidFiles.length > 0) {
      setApiError("Only JSON files are allowed.");
      return;
    }

    const formData = new FormData();

    files.forEach((file) => {
      formData.append("files", file, file.name);
    });

    try {
      setLoading(true);
console.log(AIRPORT_UPLOAD_URL,"AIRPORT_UPLOAD_URL");
      const response = await axios.post(AIRPORT_UPLOAD_URL, formData, {
        withCredentials: true,
      });

      const data = response.data;

      console.log("Airport upload response:", data);

      const initialMessages = [];

      if (data.valid_files > 0) {
        initialMessages.push(
          // `${data.valid_files} valid file(s) are being processed.`
        );
      }

      if (data.already_exists_files?.length > 0) {
        initialMessages.push(
          `ALREADY EXISTS: ${data.already_exists_files.join(", ")}`
        );
      }

      if (data.invalid_files > 0) {
        initialMessages.push(`Invalid: ${data.invalid_files}`);

        const invalidDetails = (data.invalid_file_details || [])
          .map((item) => `${item.file_name}: ${item.error}`)
          .join(" | ");

        if (invalidDetails) {
          initialMessages.push(invalidDetails);
        }
      }

      const taskId = data.task_id;

      if (data.invalid_files > 0) {
        const invalidDetails = (data.invalid_file_details || [])
          .map((item) => `${item.file_name}: ${item.error}`)
          .join("\n");

        setUploadMessage(
          [`Invalid: ${data.invalid_files}`, invalidDetails]
            .filter(Boolean)
            .join("\n")
        );
      } else {
        setUploadMessage("");
      }

      if (!taskId) {
        setLoading(false);
        return;
      }

      setUploadTaskId(taskId);
      setSelectedFiles([]);
      form.reset();

      // Keep the loading indicator until the background task completes.
      await checkAirportUploadStatus(taskId);
    } catch (error) {
      console.error(
        "Airport upload error:",
        error.response?.data || error
      );

      const detail = error.response?.data?.detail;

      const errorMessage = Array.isArray(detail)
        ? detail
            .map((item) =>
              typeof item === "string"
                ? item
                : item?.msg || JSON.stringify(item)
            )
            .join(", ")
        : typeof detail === "string"
          ? detail
          : detail?.message ||
            error.response?.data?.message ||
            "Failed to upload airport files.";

      setApiError(errorMessage);
      setLoading(false);
    }
  };

  const handleBulkGlossaryAction = async (action) => {
    if (selectedGlossaryIds.length === 0) {
      setPopupMessage("Please select at least one airport record.");
      return;
    }

    if (action === "delete") {
      setSelectedItem(null);
      setShowModal(true);
      return;
    }

    const endpoint =
      action === "approve"
        ? AIRPORT_APPROVE_URL
        : AIRPORT_DISAPPROVE_URL;

    try {
      setBulkActionLoading(true);

      const response = await api.patch(endpoint, {
        airport_ids: selectedGlossaryIds,
      });

      setPopupMessage(
        response.data?.detail ||
          response.data?.message ||
          (action === "approve"
            ? "Airports approved successfully."
            : "Airports disapproved successfully.")
      );

      setSelectedGlossaryIds([]);
      await fetchGlossaryDetails();
    } catch (error) {
      console.error(`Airport bulk ${action} error:`, error);

      const detail = error.response?.data?.detail;

      setPopupMessage(
        typeof detail === "string"
          ? detail
          : error.response?.data?.message ||
              `Failed to ${action} selected airport records.`
      );
    } finally {
      setBulkActionLoading(false);
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    const airportIdsToDelete = selectedItem?.id
      ? [selectedItem.id]
      : selectedGlossaryIds;

    if (airportIdsToDelete.length === 0) return;

    try {
      setLoading(true);

      const response = await api.delete(AIRPORT_DELETE_URL, {
        data: {
          airport_ids: airportIdsToDelete,
        },
      });

      setShowModal(false);
      setSelectedItem(null);

      setSelectedGlossaryIds((previous) =>
        previous.filter((id) => !airportIdsToDelete.includes(id))
      );

      setPopupMessage(
        response.data?.detail ||
          response.data?.message ||
          "Airport records deleted successfully."
      );

      await fetchGlossaryDetails();
    } catch (error) {
      console.error("Airport delete error:", error);

      const detail = error.response?.data?.detail;

      setPopupMessage(
        typeof detail === "string"
          ? detail
          : error.response?.data?.message ||
              "Failed to delete airport records."
      );
    } finally {
      setLoading(false);
    }
  };

  const filteredGlossaryDetails = glossaryDetails;

  return (
    <>
      <div className="user-management-page">
        <Popup
          message={popupMessage}
          onClose={() => setPopupMessage("")}
        />

        <Sidebar />

        <div className="main-wrapper">
          <Header />

          <div className="content-wrapper">
            <section className="main-section spacer-y">
              <div className="container">
                <div className="row gy-4">
                  <div className="col-xl-12">
                    <div className="common_main_bg_wrapper">
                      <div className="common_main_heading_wrapper">
                        <div className="vstack">
                          <nav className="breadcrumb_nav">
                            <ul className="breadcrumb mb-0" />
                          </nav>

                          <h1>Airports Ingestion</h1>
                        </div>
                      </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="row common-outer-card mx-2 my-5 p-3 justify-content-center">
                        <div className="col-12 col-md-6 col-lg-5">
                          <div className="form_field">
                            <label>Upload File here</label>

                            <div className="input_field">
                              <input
                                type="file"
                                className="form-control"
                                name="upload_csv"
                                accept=".json,application/json"
                                multiple
                                required
                                onChange={handleFileChange}
                              />

                              <span className="error">{apiError}</span>

                              {uploadMessage && (
                                <div
                                  style={{
                                    color: "red",
                                    whiteSpace: "pre-line",
                                    marginTop: "8px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {uploadMessage}
                                </div>
                              )}

                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                          <button
                            type="submit"
                            className="secondary_btn mt-3"
                            disabled={loading || Boolean(uploadTaskId)}
                          >
                            {loading ? "Uploading..." : "Upload"}
                          </button>
                        </div>
                      </div>
                    </form>

                    {loading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: "300px" }}
                      >
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      hasUploaded && (
                        <div className="common-table-wrapper mt-4">
                          <div className="common-table-filter-wrapper">
                            <div className="common-left-blk">
                              <div className="common_sub_heading_wrapper mb-0">
                                <h2>Uploaded Airports Listing</h2>
                              </div>
                            </div>

                            <div className="common-right-blk">
                              <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                <button
                                  type="button"
                                  className="secondary_btn"
                                  onClick={() =>
                                    handleBulkGlossaryAction("approve")
                                  }
                                  disabled={
                                    bulkActionLoading ||
                                    selectedGlossaryIds.length === 0
                                  }
                                >
                                  {bulkActionLoading
                                    ? "Please wait..."
                                    : "Approve"}
                                </button>

                                <button
                                  type="button"
                                  className="secondary_btn"
                                  onClick={() =>
                                    handleBulkGlossaryAction("disapprove")
                                  }
                                  disabled={
                                    bulkActionLoading ||
                                    selectedGlossaryIds.length === 0
                                  }
                                >
                                  Disapprove
                                </button>

                                <button
                                  type="button"
                                  className="secondary_btn"
                                  onClick={() =>
                                    handleBulkGlossaryAction("delete")
                                  }
                                  disabled={
                                    bulkActionLoading ||
                                    selectedGlossaryIds.length === 0
                                  }
                                >
                                  Delete
                                </button>
                              </div>

                              <div className="common-sort-blk">
                                <div className="common-search-blk">
                                  <input
                                    type="search"
                                    className="form-control"
                                    id="airport-search"
                                    placeholder="Search airports..."
                                    value={query}
                                    onChange={(event) => {
                                      setQuery(event.target.value);
                                      setCurrentPage(1);
                                    }}
                                    name="airport_search"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="table-blk table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>
                                    <input
                                      type="checkbox"
                                      aria-label="Select all airport records"
                                      checked={
                                        filteredGlossaryDetails.length > 0 &&
                                        filteredGlossaryDetails.every((item) =>
                                          selectedGlossaryIds.includes(item.id)
                                        )
                                      }
                                      onChange={(event) =>
                                        handleSelectAllGlossary(
                                          event.target.checked
                                        )
                                      }
                                    />
                                  </th>

                                  <th>S.No.</th>
                                  <th>Title</th>
                                  <th>IATA Code</th>
                                  <th>ICAO Code</th>
                                  <th>Country</th>
                                  <th>Latitude</th>
                                  <th>Longitude</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {filteredGlossaryDetails.length > 0 ? (
                                  filteredGlossaryDetails.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          aria-label={`Select ${getAirportName(item)}`}
                                          checked={selectedGlossaryIds.includes(
                                            item.id
                                          )}
                                          onChange={() =>
                                            handleSelectGlossary(item.id)
                                          }
                                        />
                                      </td>

                                      <td>
                                        {index + 1 + (currentPage - 1) * 20}
                                      </td>

                                      <td className="text-capitalize">
                                        {getAirportName(item)}
                                      </td>

                                      <td className="text-capitalize">
                                        {getAirportIata(item)}
                                      </td>

                                      <td className="text-capitalize">
                                        {getAirportIcao(item)}
                                      </td>

                                      <td className="text-capitalize">
                                        {getAirportCountry(item)}
                                      </td>

                                      <td>{getAirportLatitude(item)}</td>
                                      <td>{getAirportLongitude(item)}</td>

                                      <td>
                                        {item.is_approved ? (
                                          <span className="badge bg-light text-success">
                                            Active
                                          </span>
                                        ) : (
                                          <span className="badge bg-light text-danger">
                                            Inactive
                                          </span>
                                        )}
                                      </td>

                                      <td>
                                        <button
                                          type="button"
                                          className="border-0 bg-white"
                                          onClick={() =>
                                            handleDeleteClick({
                                              id: item.id,
                                              name: getAirportName(item),
                                            })
                                          }
                                          aria-label={`Delete ${getAirportName(item)}`}
                                        >
                                          <img
                                            src={IMAGE_URL + "trash-icon.svg"}
                                            alt="Trash"
                                          />
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={10} className="text-center">
                                      {apiError || "No airports records found."}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          <TableFooter
                            pagination={pagination}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                          />
                        </div>
                              )
                    )}

                    <DeleteModal
                      show={showModal}
                      onClose={() => {
                        setShowModal(false);
                        setSelectedItem(null);
                      }}
                      onConfirm={handleConfirmDelete}
                      itemName={
                        selectedItem
                          ? selectedItem.name
                          : `${selectedGlossaryIds.length} selected airport record(s)`
                      }
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
